/**
 * ============================================================
 * Bulgarian
 * ============================================================
 *
 * Translators:
 *
 * librafrog <79138819+librafrog@users.noreply.github.com>
 */

export default {
	'AdvanceHelp': 'За да преминете напред в играта, използвайте левия бутон на мишката или докоснете където и да е на игралния екран, или пък натиснете клавиша Space.',
	'AllowPlayback': 'Щракнете тук, за да разрешите аудио плейбек',
	'Audio': 'Аудио',
	'AutoPlay': 'Авто',
	'AutoPlayButton': 'Разреши авто‑плейбек',
	'AutoPlaySpeed': 'Степен за авто.възпроизвеждане',

	'Back': 'Назад',
	'BackButton': 'Бутон назад',

	'Cancel': 'Отмяна',
	'Close': 'Затвори',
	'Confirm': 'Искате ли да напуснете?',
	'Credits': 'Надписи',

	'Delete': 'Изтрий',
	'DialogLogButton': 'Покажи диалоговия дневник',

	'FullScreen': 'Цял Екран',

	'Gallery': 'Галерия',

	'Help': 'Помощ',
	'Hide': 'Скрий',
	'HideButton': 'Скрий текстовото поле',

	'iOSAudioWarning': 'Аудио настройки не са съвместими с iOS.',

	'KeyboardShortcuts': 'Клавишни комбинации',

	'Language': 'Език',
	'Load': 'Зареди',
	'LoadAutoSaveSlots': 'Авто съхранени записи',
	'LoadButton': 'Отвори Екран Зареди',
	'Loading': 'Зареждане',
	'LoadingMessage': 'Изчакай за зареждане на активите',
	'LoadSlots': 'Съхранени Записи',
	'LocalStorageWarning': 'Локално съхранение не е налично в рамките на браузъра',
	'Log': 'Дневник',

	'Music': 'Сила на Звука‑Музика',

	'NewContent': 'Налично е ново съдържание, моля обновете страницата за да приложите най-новата версия',
	'NoSavedGames': 'Няма съхранени записи',
	'NoAutoSavedGames': 'Няма авто‑съхранени записи',
	'NoDialogsAvailable': 'Липсват диалози. Диалозите ще се появат тук при появата им',

	'OK': 'ОК',
	'OrientationWarning': 'Моля, завъртете устройството, за да играете',
	'Overwrite': 'Презаписване',

	'QuickButtons': 'Бързи Меню‑бутони',
	'QuickMenu': 'Бързо Меню',
	'Quit': 'Изход',
	'QuitButton': 'Напуснете Играта',

	'Resolution': 'Резолюция',

	'Save': 'Съхрани',
	'SaveButton': 'Отвори Екран Записи',
	'SaveInSlot': 'Съхрани в Слот',
	'SelectYourLanguage': 'Изберете езика си',
	'Settings': 'Конфигурации',
	'SettingsButton': 'Отвори екран Конфигурации',
	'Show': 'Покажи',
	'Skip': 'Прескочи',
	'SkipButton': 'Режим на прескачане',
	'SlotDeletion': 'Наистина ли желаете да изтриете този слот?',
	'SlotOverwrite': 'Желаете ли да презапишете този слот?',
	'Sound': 'Сила на Звука',
	'Start': 'Начало',
	'Stop': 'Спри',

	'TextSpeed': 'Бързина на текста',

	'Video': 'Сила на Видео',
	'Voice': 'Сила на Гласа',

	'Windowed': 'Прозорец'
};